import {Role} from '@/Constant';

export function getIsMoveRepo(val: string) {
    if (!val) {
        return false;
    }
    const powerList = val.split(',');
    const res = powerList.some((item) => {
        return item === Role.Admin || item === Role.Member || item === Role.Owner;
    });
    return res;
}
